<template>
    <div class="preview_dialog">
        <div class="content" :style="{marginTop:-dialogHeight/2+'px'}" ref="previewCont" v-if="parentData.lookCont">
            <p class="title">预览<i class="iconfont" @click="closePreview">&#xe67a;</i></p>
            <div class="preview_creat_cont">
                <div class="txtbox">
                    <el-scrollbar style="height:100%">
                        <p class="text">{{parentData.text}}</p>
                    </el-scrollbar>
                </div>
                <div class="img_video_box clearFloat">
                    <div class="img_box" v-if="parentData.imgSrc">
                        <div class="img_list" v-for="item in parentData.imgSrc" :key="item.id">
                            <img :src="item.imgSrc" alt=""  @click="showfun(item.imgSrc,true)">
                        </div>
                    </div>
                    <div class="video_box" v-if="parentData.videoSrc">
                        <video :src="parentData.videoSrc" controls="controls"></video>
                        <span @click="showfun(parentData.videoSrc)"></span>
                    </div>
                    <a class="link_box" href="javasscript:;" @click="openurl(parentData.linkSrc)" v-if="parentData.linkSrc">
                        <img :src="parentData.linkCover" alt="" class="link_cover_img">
                        <span class="link_title">{{parentData.linkTitle}}</span>
                    </a>
                </div>
            </div>
            <div class="limit_box">
                可见范围：<i :class="{active:parentData.limit}">{{ parentData.limit? '私密':'公开'}}</i>
            </div>
        </div>
<!--        单独预览图片视频-->
        <div class="prievew_box" v-if="parentData.lookPic">
            <i class="iconfont" @click="closePreview">&#xe67a;</i>
            <img width="100%" :src="parentData.imgList" alt="" class='lookImg' v-if="parentData.lookImg">
            <video :src="parentData.videoList" autoplay v-else controls="controls"></video>
        </div>

        <div class="showbox"  v-if="showslef.show">
            <div class="prievew_box">

                <i class="iconfont" @click="close">&#xe67a;</i>
                <img width="100%" :src="showslef.src" alt="" class='lookImg' v-if="showslef.isimg">
                <video :src="showslef.src" autoplay v-else controls="controls"></video>
            </div>
        </div>
    </div>
</template>

<script>
	export default {
		name: "previewDialog",
        props:{
            parentData:{
                type:Object,
                default(){
                    return {
                        text:'这是没有接收到数据时默认值'
                    }
                }
            },
        },

        data(){
		    return{
		        dialogHeight:'',
                showslef:{
                    show:false,
                    isimg:false,
                    src:''
                }
            }
        },
        methods:{
		    computeHeight(){
                this.dialogHeight=this.$refs.previewCont.clientHeight;

            },
            closePreview(){
		        this.$emit("closePreview");
            },
            showfun(src,bool){
                this.showslef={
                    show:true,
                    isimg:bool,
                    src:src
                }
            },
            close(){
                this.showslef.show=false
            },
            openurl(url){
                window.open(url)
            }
        },
        created() {

        },
        mounted() {
		    if(this.parentData.lookCont){
                this.computeHeight()
		    }
            this.$nextTick(()=>{
                let h = $('.txtbox p').height()
                console.log('777777777777',h)
                if(h<=180){
                    $('.txtbox').css('height',h+17+'px')
                }else{
                    $('.txtbox').css('height','180px')
                }
            })
        }
    }
</script>

<style scoped lang="less">
    @import "../../../assets/css/publicVariable";
    @contWidth:660px;
    .preview_dialog{
        overflow: auto;
        .positionFix(@p:fixed;@t:0;@l:0;@r:0;@b:0;@bg:rgba(0,0,0,0.4);@z:10);
        .content {
            width: @contWidth - 60px;
            padding: 0 30px 10px;
            margin-left: -@contWidth/2;
            .positionFix(@p:absolute;@t:50%;@l:50%;@bg:#fff;);
            .borderRadius(8px);
            .title {
                font-size: 18px;
                color: #2A2A2A;
                padding: 23px 0 22px 0;
                .positionFix(@bg:#fff);

                i {
                    color: #93999F;
                    font-size: 16px;
                    cursor: pointer;
                    padding: 10px;
                    .positionFix(@p:absolute;@r:-10px;@t:13px;);
                }
            }
            .preview_creat_cont{
                .text{
                    line-height: 28px;
                    font-size:14px;
                    color:#2A2A2A;
                    // .ellipsisStyle(3);
                }
                .img_video_box{
                    margin-top:24px;
                    max-width: 330px;
                    img{
                        width:97px;
                        height:97px;
                        float:left;
                        float:left;
                        margin:0 10px 10px 0;
                        .borderRadius(2px);
                    }
                    .video_box{
                        width:228px;
                        height:228px;
                        position: relative;
                        video{
                            max-width:100%;
                            max-height:100%;
                            transform: translate(-50%,-50%);
                            .positionFix(@p:absolute;@t:50%;@l:50%;);
                        }
                        span{
                            width:68px;
                            height:68px;
                            transform: translate(-50%,-50%);
                            cursor: pointer;
                            .borderRadius(50%);
                            .positionFix(@p:absolute;@t:50%;@l:50%;@z:1;);
                            background:url('../../../../static/img/play_icon1.png')no-repeat center/100%;
                        }
                    }
                    .link_box{
                        width:294px;
                        height:48px;
                        border:1px solid #E1E1E4;
                        display: flex;
                        padding:6px;
                        box-sizing: border-box;
                        background: #F0F3F6;
                        .link_cover_img{
                            width:36px;
                            height:36px;
                            margin:0 6px 0 0;
                        }
                        .link_title{
                            color:#2A2A2A;
                            font-size:12px;
                            line-height: 18px;
                            text-align: left;
                            flex: 1;
                            .ellipsisStyle(2);
                        }
                    }
                }
            }
            .limit_box{
                line-height: 72px;
                border-top:1px solid #DADEE0;
                font-size:14px;
                color:#93999F;

                .active{
                    color:#e35c5a;
                }
            }
        }
        .prievew_box{
            min-height:400px;
            min-width:500px;
            max-width:700px;
            max-height:520px;
            padding:40px 20px;
            display: flex;
            align-items: center;
            color: #666666;
            box-shadow: 0px 0px 3px 0px rgba(40, 40, 40, 0.31);
            border: solid 0.01rem #e9e9e9;
            transform: translate(-50%,-50%);
            .positionFix(@p:absolute;@t:50%;@l:50%;@bg:#fff;@z:31;);
            .borderRadius(6px);
            img{
                width:100%;
                max-width: 500px;
                max-height: 520px;
            }
            i{
                font-size:20px;
                color:#2a2a2a;
                cursor:pointer;
                .positionFix(@p:absolute;@r:14px;@t:10px;)
            }
            video{
                width:100%;
                max-height: 520px;
            }
        }
    }
    .showbox{
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.5);
    }
</style>



// WEBPACK FOOTER //
// src/views/wechatMoments/components/previewDialog.vue